import { PaymentInputWUT } from '@wix/form-fields/wut';

export default PaymentInputWUT;
